import React, { useState, useRef, useEffect } from "react";
import { IonToast, IonLoading } from "@ionic/react";
import { urlCodigoVerificacaoUsuario, modoDev } from "../../../utils/constants";
import axiosClient from "../../../utils/axiosClient";
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "universal-cookie";
import { IonBadge } from "@ionic/react";

export default function CodigoVerificacaoUsuario() {
  const [codigo1, setCodigo1] = useState("");
  const [codigo2, setCodigo2] = useState("");
  const [codigo3, setCodigo3] = useState("");
  const [codigo4, setCodigo4] = useState("");
  const [codigo5, setCodigo5] = useState("");
  const [codigo6, setCodigo6] = useState("");

  const [loading, setLoading] = useState(false);

  const codigoRefs = [
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ];

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);
  const [email, setEmail] = useState("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const codigo_existe = urlParams.get("codigo_existe");
  const data_codigo = urlParams.get("data_codigo");
  const expiracao_codigo = urlParams.get("expiracao_codigo");
  const codigoJaEnviado =
    codigo_existe !== null &&
    codigo_existe !== undefined &&
    codigo_existe !== "null" &&
    codigo_existe !== "";

  const handleCodigoChange = (e, index) => {
    let value = e.target.value;

    if (value.length > 1) {
      value = value.slice(0, 1);
    }

    switch (index) {
      case 0:
        setCodigo1(value);
        break;
      case 1:
        setCodigo2(value);
        break;
      case 2:
        setCodigo3(value);
        break;
      case 3:
        setCodigo4(value);
        break;
      case 4:
        setCodigo5(value);
        break;
      case 5:
        setCodigo6(value);
        break;
      default:
        break;
    }

    if (value.length === 1 && index < 5) {
      codigoRefs[index + 1].current.focus();
    } else {
      if (value !== "") {
        verificarCodigo(value);
      }
    }
  };

  const verificarCodigo = async (codigoSeis) => {
    setLoading(true);
    const cookies = new Cookies();
    const codigoEnviar = `${codigo1}${codigo2}${codigo3}${codigo4}${codigo5}${codigoSeis}`;
    try {
      const response = await axiosClient.post(urlCodigoVerificacaoUsuario, {
        valor: codigoEnviar,
      });
      if (response.data.status === 1) {
        const umAnoEmMillisegundos = 365 * 24 * 60 * 60 * 1000;
        let cookieOptions;
        if (modoDev) {
          cookieOptions = {
            secure: false,
            httpOnly: false,
            path: "/",
            expires: new Date(new Date().getTime() + umAnoEmMillisegundos),
          };
        } else {
          cookieOptions = {
            secure: true,
            httpOnly: false,
            path: "/",
            expires: new Date(new Date().getTime() + umAnoEmMillisegundos),
          };
        }
        cookies.set(
          "token_usuario_agendou",
          response.data.token,
          cookieOptions,
        );

        setColorToast("success");
        setIconToast("alert-outline");
        setMensagemToast("Login efetuado com sucesso. Aguarde...");
        setTempoToast(10000);
        setTextoToast("Ok");
        setStatusToast(true);

        setTimeout(() => {
          setLoading(false);
          window.location.href = "/usuarios/inicio/";
        }, 2000);
      } else {
        setLoading(false);
        setColorToast("danger");
        setIconToast("alert-outline");
        setMensagemToast("Código inválido ou expirado.");
        setTempoToast(10000);
        setTextoToast("Ok");
        setStatusToast(true);
      }
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const emailUsuario = localStorage.getItem("email_usuario_agendou");
    if (emailUsuario) {
      setEmail(emailUsuario);
    }
  }, []);

  return (
    <div className="ion-margin">
      <IonLoading isOpen={loading} message="Aguarde..." duration={30000} />
      <IonToast
        isOpen={statusToast}
        color={colorToast}
        icon={iconToast}
        message={mensagemToast}
        onDidDismiss={() => setStatusToast(false)}
        duration={tempoToast}
        buttons={[
          {
            text: textoToast,
            role: "info",
            handler: () => {
              return;
            },
          },
        ]}
      ></IonToast>
      <div className="row" style={{ overflow: "scroll" }}>
        <div className="col-sm-4"></div>
        <div className="col-sm-4">
          <div className="ion-margin ion-text-center">
            <script src="https://cdn.lordicon.com/ritcuqlt.js"></script>
            <lord-icon
              src="https://cdn.lordicon.com/flvisirw.json"
              trigger="loop"
              delay="2000"
              style={{ width: 70, height: 70 }}
            ></lord-icon>

            <h1
              className="titulo"
              style={{
                fontSize: 14,
                fontWeight: 900,
                marginTop: 0,
              }}
            >
              Código de verificação
            </h1>
            
            <p style={{ fontSize: 14}}>
              Informe o código de 6 números enviado no seu E-mail{" "}
              <IonBadge slot="end">{email}</IonBadge>. (No caso do e-mail, verifique
              se está indo para da caixa de SPAM.) ou no seu WhatsApp.
            </p>

            {codigoJaEnviado && (
              <div className="alert alert-warning mt-3" role="alert" style={{ fontSize: 10}}>
                O código foi enviado para o seu e-mail/WhatsApp.
                {data_codigo && (
                  <>
                    <br />
                    Data do envio: {data_codigo}
                     <br />
                    Data de expiração: {expiracao_codigo}
                  </>
                )}
              </div>
            )}
          </div>
          <br />
          <div style={{ display: "flex", flexDirection: "row" }}>
            {codigoRefs.map((ref, index) => (
              <div style={{ width: "100%", margin: 0, padding: 0 }} key={index}>
                <input
                  className="inputCodigoVerificacao"
                  style={{
                    margin: 0,
                    width: 50,
                    border: "solid #333333 1px",
                    borderRadius: 11,
                  }}
                  value={
                    index === 0
                      ? codigo1
                      : index === 1
                        ? codigo2
                        : index === 2
                          ? codigo3
                          : index === 3
                            ? codigo4
                            : index === 4
                              ? codigo5
                              : codigo6
                  }
                  onChange={(e) => handleCodigoChange(e, index)}
                  type="tel"
                  ref={ref}
                />
              </div>
            ))}
          </div>
          <br /> <br />
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                marginTop: "20%",
              }}
            ></div>
          ) : (
            <span></span>
          )}
        </div>
        <div className="col-sm-4"></div>
      </div>
    </div>
  );
}
